import { Navigate, Outlet, useLocation } from 'react-router'

import { UserRole } from '../../models/User'
import { useAppSelector } from '../../store'
import Forbidden from '../Error/Forbidden'

const AdminAuth = () => {
  const myRole = useAppSelector((state) => state.user.me.userRole)
  const location = useLocation()

  return myRole === UserRole.GUEST ? (
    <Navigate to="/login" state={{ from: location }} />
  ) : myRole === UserRole.ADMIN ? (
    <Outlet />
  ) : (
    <Forbidden />
  )
}

export default AdminAuth
